import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';

export class PasswordService extends BaseService {
    protected get resourceName(): string {
        return 'auth/password';
    }

    public async forgot(email: string): Promise<AxiosResponse<void>> {
        return await this.post({ email }, 'forgot');
    }

    public async validate(token: string): Promise<AxiosResponse<{ data: { valid: boolean } }>> {
        return await this.get('reset/validate', { token });
    }

    public async reset(body: {
        token: string;
        newPassword: string;
        newPasswordConfirmation: string;
    }): Promise<AxiosResponse<void>> {
        return await this.post(body, 'reset');
    }
}

/// "a***a@empresa.com": confirma o e-mail certo sem expô-lo inteiro a quem está ao lado.
export const maskEmail = (email: string) => {
    const [user, domain] = email.trim().split('@');

    if (!user || !domain) return email;
    if (user.length <= 2) return `${user[0]}***@${domain}`;

    return `${user[0]}***${user[user.length - 1]}@${domain}`;
};
